import { ConsentGoalDto } from '@act/shared/data-transfer-objects';
import { ConsentSummaryDateLine } from '../dateLines/ConsentSummaryDateLine';
import { FlexSection } from '../../../../containers/Pillbox/components';
import { Typography } from '@mui/material';
import { GoalCardActions } from '../actions/GoalCardActions';
import { GoalCardActionItems } from '../../shared-types';

interface ConsentGoalSummaryProps {
  consent: ConsentGoalDto;
  actions: GoalCardActionItems[];
}

export const ConsentGoalSummary = ({
  consent,
  actions,
}: ConsentGoalSummaryProps) => {
  const isCompleted = consent.completed;
  const summaryBody = isCompleted ? null : (
    <Typography variant="bodyMedium">{consent.description}</Typography>
  );

  return (
    <FlexSection direction="column" gap={16}>
      <ConsentSummaryDateLine consent={consent} />
      {summaryBody}
      {!!actions.length && <GoalCardActions actions={actions} />}
    </FlexSection>
  );
};
